import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  cardsRow: {
    display: "flex",
    gap: theme.spacing(3),
    flexWrap: "wrap",
    marginTop: theme.spacing(3),
  },
  card: {
    flex: "1 1 200px",
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(1),
    borderRadius: 12,
    minWidth: 180,
  },
  cardIcon: {
    fontSize: 48,
    color: theme.palette.primary.main,
  },
  cardIconGreen: {
    fontSize: 48,
    color: "#388e3c",
  },
  cardIconOrange: {
    fontSize: 48,
    color: "#f57c00",
  },
  cardValue: {
    fontSize: 36,
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  cardLabel: {
    fontSize: 14,
    color: theme.palette.text.secondary,
    textAlign: "center",
  },
  welcome: {
    marginTop: theme.spacing(1),
  },
  actions: {
    display: "flex",
    gap: theme.spacing(2),
    marginTop: theme.spacing(4),
    flexWrap: "wrap",
  },
}));

const EpoDashboard = () => {
  const classes = useStyles();
  const history = useHistory();
  const { user } = useContext(AuthContext);

  const [stats, setStats] = useState({
    total: "—",
    partner: "—",
    partnerWithNotes: "—",
  });

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await api.get("/contacts/", {
          params: { pageNumber: 1, pageSize: 1 },
        });
        // Carica tutti i contatti per calcolare le statistiche
        const { data: all } = await api.get("/contacts/", {
          params: { pageNumber: 1, pageSize: 1000 },
        });
        const contacts = all.contacts || [];
        const partner = contacts.filter((c) => c.isPartnerFidelizzato);
        const partnerWithNotes = partner.filter((c) => c.description);
        setStats({
          total: contacts.length,
          partner: partner.length,
          partnerWithNotes: partnerWithNotes.length,
        });
      } catch (err) {
        toastError(err);
      }
    };
    load();
  }, []);

  return (
    <MainContainer>
      <MainHeader>
        <Title>{i18n.t("epoDashboard.title")}</Title>
      </MainHeader>

      <Typography variant="h6" className={classes.welcome}>
        Benvenuto, {user?.name || ""}!
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {i18n.t("epoDashboard.subtitle")}
      </Typography>

      <div className={classes.cardsRow}>
        <Paper className={classes.card} elevation={2}>
          <PeopleAltOutlinedIcon className={classes.cardIcon} />
          <span className={classes.cardValue}>{stats.total}</span>
          <span className={classes.cardLabel}>{i18n.t("epoDashboard.stats.total")}</span>
        </Paper>
        <Paper className={classes.card} elevation={2}>
          <ContactPhoneOutlinedIcon className={classes.cardIconOrange} />
          <span className={classes.cardValue}>{stats.partner}</span>
          <span className={classes.cardLabel}>{i18n.t("epoDashboard.stats.partner")}</span>
        </Paper>
        <Paper className={classes.card} elevation={2}>
          <CheckCircleOutlineIcon className={classes.cardIconGreen} />
          <span className={classes.cardValue}>{stats.partnerWithNotes}</span>
          <span className={classes.cardLabel}>{i18n.t("epoDashboard.stats.partnerWithNotes")}</span>
        </Paper>
      </div>

      <div className={classes.actions}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<ContactPhoneOutlinedIcon />}
          onClick={() => history.push("/contacts")}
        >
          {i18n.t("epoDashboard.buttons.contacts")}
        </Button>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<PersonAddIcon />}
          onClick={() => history.push("/contacts", { openNew: true })}
        >
          {i18n.t("epoDashboard.buttons.addContact")}
        </Button>
      </div>
    </MainContainer>
  );
};

export default EpoDashboard;
